import {
    decorateResponse,
    getPlural,
    hashCodeToRgbaColor
} from "@src/utility/helpers/utils";

import Accordions from "@components/ui-components/accordions";
import Breadcrumbs from "@components/ui-components/breadcrumbs";
import CommonModal from "@components/ui-components/modal";
import Flex from "@components/ui-components/flex";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import { LoaderOverlay } from "@components/spinner";
import LoadingButton from "@components/ui-components/loading-button";
import Select from "@components/fields/react-select/select";
import capitalize from "lodash/capitalize";
import size from "lodash/size";
import useTags from "./use-tags";
import { useTranslation } from "react-i18next";

const TAG_TYPES = ["people", "client", "user"];

const Tags = () => {
    const {
        data: { tags },
        loading,
        modalConfig,
        methods,
        updateLoading,
        onSubmit,
        isDirty,
        isOpen,
        handleModalConfig,
        handleActiveAccordion,
        activeAccordion,
        handleRowActions
    } = useTags();

    const { t } = useTranslation();
    const {
        control,
        formState: { errors }
    } = methods;
    const isEdit = !!size(modalConfig.row._id);

    const content = [
        {
            leftChild: {
                title: "Enter Basic Details",
                desc : "Enter the basic details of the tags which you wish to create"
            },
            rightChild: (
                <>
                    <InputField
                        errors={errors}
                        id="name"
                        label="Name"
                        name="name"
                        required
                        control={control}/>
                    {!isEdit ? (
                        <Select
                            options={decorateResponse(TAG_TYPES)}
                            errors={errors}
                            label="Type"
                            name="type"
                            id="type"
                            control={control}
                            required/>
                    ) : null}
                </>
            )
        }
    ];
    return (
        <>
            <Breadcrumbs
                items={[
                    {
                        title : "Tags",
                        active: true
                    }
                ]}/>
            <LoaderOverlay
                active={loading}
                children={
                    <>
                        <Accordions
                            state={activeAccordion}
                            className="border rounded"
                            toggle={handleActiveAccordion}
                            items={TAG_TYPES.map(type => {
                                const tagList = tags[type] || [];
                                return {
                                    id   : type,
                                    title: (
                                        <Flex
                                            justify="between"
                                            align="center"
                                            className="w-100">
                                            <h5>
                                                {capitalize(type)}{" "}
                                                {capitalize(
                                                    getPlural({ text: "tag", length: size(tagList) })
                                                )}{" "}
                                                ({size(tagList)})
                                            </h5>
                                            <LoadingButton
                                                text="New Tag"
                                                outline
                                                subject="tags"
                                                className="btn-sm align-items-center me-1"
                                                onClick={() => handleRowActions(
                                                    "new",
                                                    null,
                                                    type
                                                )
                                                }/>
                                        </Flex>
                                    ),
                                    content: (
                                        <div key={type} className="mb-4">
                                            <div className="d-flex flex-wrap gap-2">
                                                {size(tagList) ? (
                                                    tagList.map(tag => (
                                                        <div
                                                            style={{
                                                                background:
                                                                    hashCodeToRgbaColor(
                                                                        tag.name
                                                                    )
                                                            }}
                                                            className={
                                                                "p-50 rounded"
                                                            }
                                                            key={tag._id}>
                                                            <Flex align="center">
                                                                <span>
                                                                    {tag.name}
                                                                </span>
                                                                <i
                                                                    className="mdi mdi-pencil text-info cursor-pointer"
                                                                    onClick={() => handleRowActions(
                                                                        "edit",
                                                                        tag,
                                                                        tag.type
                                                                    )
                                                                    }/>
                                                                <i
                                                                    className="mdi mdi-delete text-danger cursor-pointer"
                                                                    onClick={() => handleRowActions(
                                                                        "delete",
                                                                        tag
                                                                    )
                                                                    }/>
                                                            </Flex>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <Flex justify="center" className="w-100">
                                                        {" "}
                                                        <b>    {t(
                                                            "No tags defined yet"
                                                        )}</b>
                                                    </Flex>
                                                )}
                                            </div>
                                        </div>
                                    )
                                };
                            })}
                            controlled/>
                    </>
                }/>
            <CommonModal
                title={`${isEdit ? "Edit" : "Add"} Tag`}
                body={<FormView content={content} />}
                confirmButton={{
                    txt    : isEdit ? "Update" : "Add",
                    icon   : "content-save",
                    onClick: onSubmit,
                    loading: updateLoading
                }}
                type="extraLarge"
                isDirty={isDirty}
                loading={loading}
                handleModal={handleModalConfig}
                isOpen={isOpen}/>
        </>
    );
};

export default Tags;
